import {
	CheckCircleFilled,
	FileImageOutlined,
	ReloadOutlined,
} from "@ant-design/icons"
import { Button } from "components/Button/Button"
import { ErrorStatus } from "components/ErrorStatus/ErrorStatus"
import { Image } from "components/Image/Image"
import { WeightIcon } from "icons/WeightIcon"
import { Visit } from "interface/visit"
import { usePatientLastestScan } from "services/patients"
import { dateFormatter } from "utils/date"
import { useStepCompletion } from "./useStepCompletion"

export function StepTestScan({ visit }: { visit: Visit }) {
	const {
		data: latestScan,
		isError,
		refetch,
		isRefetching,
		isRefetchError,
		error,
	} = usePatientLastestScan(visit.patient?.id!)
	const { markStepAs, testScan } = useStepCompletion(visit)

	return (
		<div className="flex size-full grow flex-col items-center justify-center gap-3 text-center">
			{testScan && latestScan && (
				<>
					<CheckCircleFilled
						aria-hidden
						className="text-[48px] text-green-60"
					/>
					<span>The test scan is complete</span>
				</>
			)}

			{!testScan && (
				<>
					Complete a test scan
					<div className="relative flex flex-col items-center gap-1">
						{!latestScan?.imageUrl && (
							<div className="flex size-20 items-center justify-center rounded-2xl bg-white">
								<WeightIcon.Null
									aria-label="No image available yet"
									className="size-6 text-navy-60"
								/>
							</div>
						)}

						{!!latestScan?.imageUrl && (
							<Image
								alt={`Latest image captured at ${dateFormatter(latestScan.capturedAt)}`}
								src={latestScan?.imageUrl}
								rootClassName="rounded-2xl"
								className="size-20 rounded-2xl bg-white object-cover"
								classNames={{
									cover: "rounded-2xl",
								}}
								preview
							/>
						)}

						{isRefetching && (
							<div className="absolute top-0 size-20 rounded-2xl bg-black opacity-60"></div>
						)}

						<Button
							type="link"
							loading={isRefetching}
							icon={
								latestScan ? (
									<ReloadOutlined aria-hidden />
								) : (
									<FileImageOutlined aria-hidden />
								)
							}
							onClick={() => refetch()}
						>
							{latestScan ? "Refresh image" : "Check for image"}
						</Button>

						<ErrorStatus show={isError && !isRefetching}>
							<p className="line-clamp-2">{error?.message}</p>
						</ErrorStatus>
					</div>
					<Button
						type="primary"
						disabled={!latestScan || testScan || isError || isRefetchError}
						className="mt-auto w-full"
						onClick={() => markStepAs("testScan")}
					>
						Mark as complete
					</Button>
				</>
			)}
		</div>
	)
}
